const actions = {
  FETCH_LISTS_START: 'FETCH_LISTS_START',
  FETCH_LISTS_DONE: 'FETCH_LISTS_DONE',
  FETCH_LISTS_ERROR: 'FETCH_LISTS_ERROR',
  FETCH_LISTS_CANCELLED: 'FETCH_LISTS_CANCELLED',

  FETCH_CANDIDATE_SEARCH_LISTS_START: 'FETCH_CANDIDATE_SEARCH_LISTS_START',
  FETCH_CANDIDATE_SEARCH_LISTS_DONE: 'FETCH_CANDIDATE_SEARCH_LISTS_DONE',
  FETCH_CANDIDATE_SEARCH_LISTS_ERROR: 'FETCH_CANDIDATE_SEARCH_LISTS_ERROR',
  FETCH_CANDIDATE_SEARCH_LISTS_CANCELLED: 'FETCH_CANDIDATE_SEARCH_LISTS_CANCELLED',

  fetchLists: (payload) => ({ type: actions.FETCH_LISTS_START, payload }),
  fetchCandidateSearchLists: () => ({ type: actions.FETCH_CANDIDATE_SEARCH_LISTS_START }),
};
export default actions;
